/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */

export interface ISpecialFeatureMessage {
    specialFeatureName: string;
    specialFeatureMessage: string;
}

export interface IPackageListingAppBaseText {
    filtersTitle: string;
    clearAllFiltersButtonText: string;
    productionFilterDefaultValue: string;
    productionFilterLabel: string;
    dayOfWeekFilterDefaultValue: string;
    dayOfWeekFilterLabel: string;
    timeSlotDefaultValue: string;
    timeSlotFilterLabel: string;
    miniCartTitle: string;
    minimumPerformanceRequiredMessage: string;
    addAdditionalPerformancesMessage: string;
    addAdditionalPerformancesForPerformanceGroupMessage: string;
    maxPerformancesMessage: string;
    maxPerformancesForGroupMessage: string;
    removeButtonText: string;
    continueToSeatingButtonText: string;
    reservePackageButtonText: string;
    viewPerformancesButtonText: string;
    dropAPerformanceText: string;

    flexPackageErrorMessage:string;
    packageSubtotalTitle: string;
    selectTicketsTitle: string;
    missingPriceTypeSelectionMessage: string;
    selectAZoneLabel: string;
    selectSecondZoneMessageString: string;
    selectSecondZoneLabel: string;
    selectAZoneDropdownDefaultValue: string;
    changeZoneButtonText: string;
    synopsisHeaderLabel: string;
    showSynopsisButtonText: string;
    hideSynopsisButtonText: string;

    loadingLabel: string;
    hidePerformancesButtonText: string;
    selectSubscriptionButtonText: string;
    addToCartButtonText: string;
    loadMorePerformancesButtonText: string;

    packageLoadErrorMessage: string;
    performanceUnavailableErrorMessage: string;

    generalPackageProcessingErrorMessage: string;
    packageProcessingMessage: string;

    orderNotesTitle: string;
    orderNotesOptionalText: string;
    orderNotesPlaceholder: string;


    seatingPreferencesTitle: string;
    seatingPreferencesDefaultText: string;
    seatingPreferenceOptions: Array<string>;

    // Not from api but ~about~ api
    requesting: boolean;
    apiError: any;

    loaderImageUrl: string;
    specialFeatureMessages: ISpecialFeatureMessage[];
}

export const defaultBaseText: IPackageListingAppBaseText = {
    filtersTitle: "Filters",
    selectSubscriptionButtonText: "Select",
    clearAllFiltersButtonText: "Clear all filters",
    productionFilterDefaultValue: "",
    dayOfWeekFilterDefaultValue: "",
    timeSlotDefaultValue: "",
    productionFilterLabel: "Productions",
    dayOfWeekFilterLabel: "Days",
    timeSlotFilterLabel: "Times",
    miniCartTitle: "Your subscriptions",
    minimumPerformanceRequiredMessage: "Select at least {0} performances",
    addAdditionalPerformancesMessage: "Select at least {0} more performances",
    addAdditionalPerformancesForPerformanceGroupMessage: "Select at least {0} more performances for {1}",
    maxPerformancesMessage: "You've reached the max for this package",
    maxPerformancesForGroupMessage: "You've reached the max for {0}",
    removeButtonText: "Remove",
    continueToSeatingButtonText: "Continue to seating",
    reservePackageButtonText: "Reserve Package",
    flexPackageErrorMessage: "Package minimum is not reached",
    packageSubtotalTitle: "Subtotal",
    loadingLabel: "Loading",
    hidePerformancesButtonText: "Hide",
    viewPerformancesButtonText: "View",
    addToCartButtonText: "Add to cart",
    loadMorePerformancesButtonText: "Load more performances",
    generalPackageProcessingErrorMessage: "There was an error processing your package request. Please contact box office",
    packageLoadErrorMessage: "Error Loading Packages",
    packageProcessingMessage: "Processing",
    performanceUnavailableErrorMessage: "There was an issue with performance {0}. Please pick another performance or try again",
    hideSynopsisButtonText: "Hide Synopsis",
    showSynopsisButtonText: "Read Synopsis",
    synopsisHeaderLabel: "Synopsis",
    selectTicketsTitle: "Select Tickets",
    seatingPreferencesTitle: "Seating Preferences",
    seatingPreferencesDefaultText: "Choose a preference",
    seatingPreferenceOptions: [],
    missingPriceTypeSelectionMessage: "Please select a price type to continue",
    selectAZoneLabel: "Select a Zone",
    selectSecondZoneMessageString: "",
    selectSecondZoneLabel: "Select your second choice",
    selectAZoneDropdownDefaultValue: "Select a zone to continue",
    changeZoneButtonText: "Change Zone",
    orderNotesTitle: "Order Notes",
    orderNotesPlaceholder: "500 characters or fewer",
    orderNotesOptionalText: "Optional",
    dropAPerformanceText: "*This performance can be dropped.",
    requesting: false,
    apiError: null,
    loaderImageUrl: "",
    specialFeatureMessages: [],
}